import { useMutation, useQuery } from "@apollo/client";
import React, { useState, useContext, useEffect } from "react";
import Filter from "./components/Filter";
import beneficiary from "../../gql/beneficiary";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";

import AddBeneficiaryModal from "./components/AddBeneficiaryModal";
import ConformationModal from "../../components/ConformationModal";
// import { ToastContainer, toast } from "react-toastify";
import toast from "react-hot-toast";
import { appContext } from "../../context/ContextProvider";
import { useNavigate } from "react-router-dom";
import Pagination from "../../components/Pagination";
import DownloadExcel from "../../components/DownloadExcel";
import FilterModal from "./components/modals/FilterModal";

import CloseIcon from "@mui/icons-material/Close";

import "./styles/BeneficiaryList.css";
import BeneficiaryDetailModal from "./components/BeneficiaryDetailModal";
import AppModal from "../../components/AppModal";
import { BsGenderMale, BsGenderFemale } from "react-icons/bs";

import { FaDownload, FaFilter, FaGenderless, FaUpload } from "react-icons/fa";
import { IconButton, Tooltip, Dialog } from "@mui/material";

import { TbEditCircle } from "react-icons/tb";
import { MdOutlineFileUpload, MdOutlineRemoveRedEye } from "react-icons/md";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useTranslation } from "react-i18next";

import TableLoader from "../../common/TableLoader";
import UploadExcelFile from "./UploadExcelFile";
import axios from "axios";
import AppLoader from "../../components/AppLoader";
import CustomButton from "../../shared/CustomButton";
import { IoMdCloseCircle } from "react-icons/io";
import TableSkeletonLoader from "../../common/TableLoading";
import AppButton from "../../shared/AppButton";
import AppTable from "../../shared/AppTable";

function BeneficiaryList(props) {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [selectedDetailID, setSelectedDetailID] = useState(null);
  const [openExcelFileUploadModal, setOpenExcelFileUploadModal] =
    useState(false);
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const [excelData, setExcelData] = useState([
    { id: 1, name: "John Doe", email: "john.doe@example.com" },
    { id: 2, name: "Jane Doe", email: "jane.doe@example.com" },
    { id: 3, name: "Bob Smith", email: "bob.smith@example.com" },
  ]);
  const { permissions } = useContext(appContext);
  const [item, setItem] = useState({
    id: 11,
    document_id: 22,
    firsr_name: "zain",
    middle_name: "khan",
    full_name: "zain khan",
    family_name: "Royal",
    beneficiary_file_id: "11",
    dob: "2000",
    eHealth_id: "2030",
    nationality: "Pak",
    residency_type: "93",
    document_type: "344",
    contact_number: "432",
    martial_status: "salman",
    gender: "salman45",
    blood_group: "a",
    preferred_language: "234",
    emergency_number: "34",
    email: "3030",
    address_line: "",
    street_line: "34",
    city: "93",
    state: "344",
    country: "432",
    postal_code: "34",
    nphies_id: "93",
    providers_id: "344",
    is_new_born: true,
  });

  const [showDetails, setShowDetails] = useState(false);

  const [showFilters, setShowFilters] = useState(true);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const [currentItem, setCurrentItem] = useState({
    _id: 0,
    Address: "a",
    IqamaExpiry: "arbi@gmail.com",
    StartDate: "name",
    Department: "salman45",
    Gender: "2345",
    StatusId: 1,
  });

  const [limit, setLimit] = useState(15);
  const [pageNo, setPageNo] = useState(
    +JSON?.parse(localStorage?.getItem("beneficiariesPageNo"))
      ? +JSON?.parse(localStorage?.getItem("beneficiariesPageNo"))
      : 1,
  );

  const {
    loading: excelDataLoading,
    error: excelDataError,
    data: excelDataResponse,
    refetch: refetchExcelDataResponse,
  } = useQuery(beneficiary.GET_PATIENTS_IN_EXCEL, {
    variables: { filters: { limit: limit, page: pageNo } },
    skip: true,
  });

  useEffect(() => {
    if (excelDataResponse) {
      setExcelData(JSON.parse(excelDataResponse?.listPatientsExcel?.data));
    }
  }, [excelDataResponse]);

  const [delEntry, {}] = useMutation(beneficiary.DEL_BENEFICIARY, {
    update(proxy, result) {
      onSuccessfulRequestResponse(result.data);
    },
    onError(error) {
      onResponseError(error.graphQLErrors[0]);
    },
  });

  const onSuccessfulRequestResponse = (data) => {
    if (data.deletePatient) {
      toast.success("Successfully Deleted!");
      refetch();
    } else {
    }
  };

  const onResponseError = (error) => {
    toast.error(`${error.message}`);
  };

  const { loading, error, data, refetch } = useQuery(
    beneficiary.GET_ALL_PATIENTS,
    {
      variables: { filters: { limit: limit, page: pageNo } },
    },
  );

  useEffect(() => {
    if (error?.graphQLErrors[0]?.message) {
      toast.error(error?.graphQLErrors[0]?.message);
    }
  }, [error]);

  const onPageChange = (currentPage) => {
    setPageNo(currentPage);
    refetch({ filters: { limit: limit, page: currentPage } });
    // refetchExcelDataResponse({ filters: { limit: limit, page: currentPage } });
  };

  // if (error) return <p>Error: {error.message}</p>;

  const onClickDelete = (item) => {
    setCurrentItem(item);
    setShowDeleteAlert(true);
  };

  const deleteEntry = () => {
    delEntry({ variables: { input: { ID: currentItem._id } } });
    setShowDeleteAlert(false);
  };

  const onClickEdit = (el) => {
    navigate("/beneficiary/edit/form", { state: { item: el } });
    // setCurrentItem(el);
    // setShowEditModal(true);
  };

  const tableHeaders = [
    { name: t("SQ #") },
    { name: t("Full Name") },
    { name: t("File No") },
    { name: t("Document Type") },
    { name: t("Document") },
    { name: t("Contact No") },
    { name: t("Age") },
    { name: t("Actions") },
  ];

  const documentTypes = [
    { id: "VP", name: t("VISA") },
    { id: "PPN", name: t("Passport") },
    { id: "PRC", name: t("Permanent Resident Card Number") },
    { id: "MR", name: t("Medical record number") },
    { id: "NI", name: t("National Card") },
  ];

  const handleViewClick = (el) => {
    setItem(el);
    setShowDetails(true);
    navigate("/beneficiary/details", { state: { item: el } });
  };

  function calculateAge(dateOfBirth) {
    // Parse the date of birth string into a Date object
    const dob = new Date(dateOfBirth);

    // Get the current date
    const currentDate = new Date();

    // Calculate the difference in years
    const age = currentDate.getFullYear() - dob.getFullYear();

    // Check if the birthday has occurred this year
    if (
      currentDate.getMonth() < dob.getMonth() ||
      (currentDate.getMonth() === dob.getMonth() &&
        currentDate.getDate() < dob.getDate())
    ) {
      // If not, subtract 1 from the age
      return age - 1;
    }

    // Otherwise, return the calculated age
    return age;
  }

  const downloadExcelFile = (fileName) => {
    refetchExcelDataResponse({ filters: { limit: limit, page: pageNo } }).then(
      (res) => {
        const data = JSON.parse(res?.data?.listPatientsExcel?.data);
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        const fileData = new Blob([excelBuffer], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        saveAs(fileData, `${fileName}.xlsx`);
      },
    );
  };

  const downloadCreateBeneficiaryExcelFile = async () => {
    try {
      const token = localStorage.getItem("token");
      const tokenWithoutQuotes = token.replace(/"/g, "");
      const response = await fetch(
        `https://stage.api.connect.supergitsa.com/api/downloadExcel `,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${tokenWithoutQuotes}`,
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const blob = await response.blob();
      const contentDisposition = response.headers.get("Content-Disposition");

      let filename = "beneficiary.xlsx";

      if (contentDisposition) {
        const filenameMatch = contentDisposition.match(/filename="?(.+)"?/);
        if (filenameMatch && filenameMatch[1]) {
          filename = filenameMatch[1];
          if (!filename.endsWith(".xlsx")) {
            filename += ".xlsx";
          }
        }
      }
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error(t("Error downloading the file:"), error);
    }
  };

  const columns = [
    // {
    //   header: t("SQ #"),
    //   render: (row, index) => pageNo * limit + index + 1 - limit,
    // },
    {
      header: t("Full Name"),
      field: "full_name",
      render: (row) => (
        <span className="capitalize font-medium">{row.full_name}</span>
      ),
    },
    { header: t("File No"), field: "file_no" },
    {
      header: t("Document Type"),
      render: (row) => (
        <span>
          {documentTypes.find((d) => d.id === row.document_type)?.name ||
            row.document_type}
        </span>
      ),
    },
    { header: t("Document"), field: "document_id" },
    { header: t("Contact No"), field: "contact_number" },
    {
      header: t("Age"),
      align: "center",
      render: (row) => (
        <div className="flex items-center gap-2 justify-center">
          {calculateAge(row.dob)}
          {row.gender === "male" ? (
            <BsGenderMale className="text-blue-500" />
          ) : (
            <BsGenderFemale className="text-pink-500" />
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      <div className="superGit_container !p-0">
        <div className="flex justify-between items-start flex-col md:flex-row gap-2 mb-2">
          <div className="w-full sm:w-[calc(100%-150px)]">
            {/* <Tooltip
              placement="right"
              title={t("Beneficiary List")}
              className="my-auto !mt-2"
            > */}
              <span className="font-semibold text-black/70 text-lg ">
                {t("BENEFICIARIES")}
                <span className=" text-lg ml-1">
                  ({data?.listPatients?.total || 0}{" "}
                  <span className="text-xs font-bold italic">
                    {t("Entries")}
                  </span>
                  )
                </span>
              </span>
            {/* </Tooltip> */}
          </div>
          <div className="w-full flex gap-1.5 flex-col md:flex-row justify-end">
            <AppButton
              label={t("Download")}
              variant="outlined"
              onClick={() => downloadExcelFile("Beneficiaries")}
              startIcon={<FileDownloadOutlinedIcon />}
              className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
            />
            <AppButton
              label={t("download_sample")}
              variant="outlined"
              onClick={downloadCreateBeneficiaryExcelFile}
              startIcon={<FileDownloadOutlinedIcon />}
              className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
            />
            <AppButton
              label={t("upload_excel")}
              variant="outlined"
              startIcon={<MdOutlineFileUpload />}
              onClick={() => setOpenExcelFileUploadModal(true)}
              className="!border-[#2441c9] !text-[#2441c9] hover:!bg-primary/10"
            />
            <AppButton
              label={t("Create Beneficiary")}
              startIcon={<AddIcon />}
              onClick={() => navigate("/beneficiary/form")}
            />
          </div>
        </div>

        {showFilters && (
          <div className="bg-white border border-slate-200 rounded-lg p-2 mb-2">
            <FilterModal
              refetch={refetch}
              setPageNo={setPageNo}
              setLimit={setLimit}
              pageNo={pageNo}
              setIsLoading={setIsLoading}
            />
          </div>
        )}
        <AppTable
          columns={columns}
          data={data?.listPatients?.data}
          loading={loading || isLoading}
          onView={handleViewClick}
          // onView={(el) => {
          //   handleClickOpen();
          //   setSelectedDetailID(el.id);
          // }}
          onEdit={onClickEdit}
          LoaderComponent={<TableSkeletonLoader columnCount={7} rowCount={8} />}
        />

        <div>
          <Pagination
            currentPage={pageNo}
            totalPages={data?.listPatients?.pages}
            onPageChange={onPageChange}
          />
        </div>
        <AddBeneficiaryModal
          item={currentItem}
          showBeneficiaryModal={showEditModal}
          setShowBeneficiaryModal={setShowEditModal}
          refetch={refetch}
        />
        <ConformationModal
          open={showDeleteAlert}
          setOpen={setShowDeleteAlert}
          onDelete={deleteEntry}
        />

        <BeneficiaryDetailModal
          open={open}
          setOpen={setOpen}
          handleClose={handleClose}
          handleClickOpen={handleClickOpen}
          selectedDetailID={selectedDetailID}
          setSelectedDetailID={setSelectedDetailID}
        />
        <ExcelFileUploadModal
          openExcelFileUploadModal={openExcelFileUploadModal}
          setOpenExcelFileUploadModal={setOpenExcelFileUploadModal}
          refetch={refetch}
        />
      </div>
    </>
  );
}

const ExcelFileUploadModal = ({
  openExcelFileUploadModal,
  setOpenExcelFileUploadModal,
  refetch,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [file, setFile] = useState(null);

  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e?.preventDefault();

    if (!file) {
      toast.error(t("please_select_file_to_upload"));
      return;
    }
    try {
      setError(null);

      const formData = new FormData();
      formData.append("file", file);
      setIsLoading(true);
      const token = localStorage.getItem("token");
      const tokenWithoutQuotes = token.replace(/"/g, "");
      const res = await axios.post(
        "https://stage.api.connect.supergitsa.com/api/uploadExcel",
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${tokenWithoutQuotes}`,
          },
        },
      );
      if (res) {
        toast.success(res?.data?.message);
        setFile(null);
        setOpenExcelFileUploadModal(false);
        refetch({ filters: { limit: 15, page: 1 } });
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);

      if (error?.response?.data?.errors?.length > 0) {
        toast.error(error?.response?.data?.message);
        setError(error?.response?.data?.errors);
      } else {
        toast.error(error?.response?.data?.error);
      }
    }
  };

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));
  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      open={openExcelFileUploadModal}
      PaperProps={{
        className:
          "w-full !max-w-[750px] sm:max-w-sm md:max-w-md lg:max-w-lg xl:max-w-xl ",
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {t("Upload Attachment")}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={() => setOpenExcelFileUploadModal(false)}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon disabled={isLoading} />
      </IconButton>
      <DialogContent dividers>
        <form onSubmit={handleSubmit}>
          <div>
            <UploadExcelFile
              isLoading={isLoading}
              file={file}
              setFile={setFile}
            />
            <div className="flex items-center justify-end mt-3">
              <AppButton
                disabled={isLoading}
                type="submit"
                startIcon={<AddIcon />}
                isLoading={isLoading}
              >
                {t("Upload file")}
              </AppButton>
            </div>
          </div>
        </form>
        {error && (
          <div className="mt-3 border border-red-500 bg-red-100 p-2 rounded-md relative">
            <div className="absolute top-[-5px] right-[-5px]">
              <IoMdCloseCircle
                size={20}
                className="text-red-500 cursor-pointer"
                onClick={() => setError(null)}
              />
            </div>
            {error?.map((err, index) => (
              <p key={index} className="text-red-500 text-sm mb-1">
                {err}
              </p>
            ))}
          </div>
        )}
        {/* <AppLoader showLoader={isLoading} /> */}
      </DialogContent>
    </BootstrapDialog>
  );
};

export default BeneficiaryList;
